import React from 'react'
import FormularioAltaPagoSinFactura from '../../moleculas/FormularioAltaPagoSinFactura/FormularioAltaPagoSinFactura'

export default function NuevoPagoSinFacturaContainer() {
  return (
    <div> 
      <FormularioAltaPagoSinFactura />
    </div>
  )
}
